import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import partial from 'react-utils/partial';
import { StyledTier } from './FeatureStyledComponents';

const FeaturesTierPicker = ({
  activeColumn,
  headerKeys,
  setActiveColumn
}) => /*#__PURE__*/_jsx(StyledTier, {
  children: headerKeys.slice(1).map((headerKey, i) => /*#__PURE__*/_jsx("button", {
    onClick: partial(setActiveColumn, i),
    className: activeColumn === i ? 'active' : '',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `upgrades.productCatalog.tableHeader.${headerKey}`
    })
  }, i))
});

export default FeaturesTierPicker;